<style lang="scss">
.monitorMachineMoldTable .el-progress-bar__outer {
  background: #606672;
}

.monitorMachineMoldTable .el-progress__text {
  color: #ffffff;
}

.monitorMachineMoldTable::before {
  z-index: inherit;
}

.monitorMachineMoldTable.el-table {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--border:after,
.monitorMachineMoldTable.el-table--group:after,
.monitorMachineMoldTable.el-table:before {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table tr {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #33333a !important;
}

.monitorMachineMoldTable .el-table td.gutter,
.monitorMachineMoldTable.el-table th.gutter {
  background: rgba(7, 53, 245, 1) !important;
}

//.monitorMachineMoldTable .el-table__body-wrapper {
//  background: #1d1d24;
//}

// 滚动条的宽度
.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

/*滚动条里面轨道*/
// .monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	border-radius: 2px;
// 	background: #1D1D24;
// }</style>

<style lang="scss" scoped="scoped">
.cell-class-name {
  border-bottom: 1px solid red !important;
}

.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 10px 10px 10px 20px; background: rgba(3, 0, 108, 1);display: flex;flex-direction: column;">
    <div ref="top" class="biankuang" style="width: 100%;display:flex;justify-content:space-around;align-items: center;flex-shrink: 0;padding: 10px 0px;">
      <div style="display:flex;justify-content:space-around;align-items:center;">
        <img style="width: 40px;height: auto;" src="../../../../../../../assets/img/web/yongxin/昨日设备报警统计.png" />
        <p style="font-size:20px;color:white;margin: 0px 10px;">昨日设备报警统计</p>
        <p style="color: rgba(58, 220, 255, 1);font-weight: bold;font-size: 40px;">{{ tongji }}</p>
      </div>
    </div>
    <div style="display: flex;justify-content: space-between;margin-top: 20px;flex-shrink: 0;">
      <div class="biankuang" style="height: 100%;width: 100%;display:flex;flex-direction: column;">
        <div ref="title" class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          报警原因Worst3
        </div>
        <div style="width: 100%;display: flex;justify-content: space-between" :style="{ height: chartHeight + 'px' }">
          <div id="yongxinErrorChart1" style="flex:1" :style="{ height: chartHeight + 'px' }"></div>
        </div>
      </div>
    </div>
    <div class="biankuang" style="flex: 1;margin-top: 20PX;" ref="tableContainer">
      <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
        <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          报警设备
        </div>
      </div>
      <div :style="{ height: contentHeight + 'px' }" style="padding: 0px 16px;">
        <el-table ref="table" class="monitorMachineMoldTable" :data="list2" style="width: 100%" :max-height="contentHeight" :row-style="{ height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'rgba(7, 53, 245, 1)', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: 'rgba(7, 53, 245, 1)', color: 'white', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '16px' }" cell-class-name="cell-class-name">
          <el-table-column :label="$t('shebeimingcheng')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ $t(scope.row.equipmentName) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('yichangmiaoshu')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ $t(scope.row.desc) }}
              </div>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_machine_model_machine_wait',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      chartHeight: 240,
      interval: null,
      timer: null,
      contentHeight: 0,
      rowHeight: 0,
      list1: [],
      list2: [],
      tongji: 0,
      chart1: null,
      option1: null,
      isStopListScroll: false
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/equipment/alarm/list', {});
      this.tongji = response.data.total;
      this.list1 = response.data.topList;
      //取前三个值
      if (this.list1.length > 3) {
        this.list1 = this.list1.slice(0, 3);

      }
      this.list2 = response.data.infoList;


      this.makeChart();

    },
    makeChart() {
      let xData = this.list1.map(item => {
        return item.desc;
      });
      let yData = this.list1.map(item => {
        return item.count;
      });
      // this.chartHeight = this.$refs.container.offsetHeight - this.$refs.top.offsetHeight - this.$refs.title.offsetHeight - 40;
      if (!this.chart1) {
        this.initChart1();
      }
      this.option1.xAxis.data = xData;
      this.option1.series[0].data = yData;
      this.chart1.setOption(this.option1);

    },
    initChart1() {
      this.option1 = {
        backgroundColor: null,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              formatter: '{value} '
            },
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: 'rgba(0,0,0,0.8)',
          borderWidth: 0,
          textStyle: {
            color: '#C0C4CC'
          },
          valueFormatter: value => {
            return value; // value.toFixed(2) + 'kwh';
          }
        },
        grid: {
          left: '20',
          right: '20',
          bottom: '10',
          top: '16',
          containLabel: true
        },

        dataZoom: [
          {
            show: false,
            height: 8,
            xAxisIndex: [0],
            bottom: 0,
            start: 0,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: 'rgba(255, 255, 255,1'
            },
            textStyle: {
              color: 'transparent',
              fontSize: 12
            },
            fillerColor: '#CBCED4',
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            showDataShadow: false,
            brushSelect: false
          },
          {
            type: 'inside',
            disabled: false
          }
        ],
        xAxis: {
          show: true,
          type: 'category',
          name: '',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 12
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: false,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 12,
            color: 'white'
            // formatter: month => {
            //   return month.substring(4, 6) + this.$t('yue');
            // }
          },
          data: []
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            name: '',
            min: 0,
            nameTextStyle: {
              color: '#909399'
            },

            axisLine: {
              show: false,
              lineStyle: {
                color: '#909399'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value} ',
              rotate: 0,
              textStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed',
                color: '#606672'
              }
            }
          }
        ],

        series: [
          {
            name: this.$t(''),
            type: 'bar',
            barWidth: '24px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#E5DA6F'
                  },
                  {
                    offset: 1,
                    color: '#FB8835'
                  }
                ]),
                barBorderRadius: 12
              }
            },
            label: {
              normal: {
                // formatter: (params) => {
                //   return params.value.toFixed(2)
                // },
                show: true,
                rotate: 0,
                color: 'white',
                position: 'top',
                fontSize: 12
              }
            },
            data: []
          }
        ]
      };

      var chartDom = document.getElementById('yongxinErrorChart1');
      this.chart1 = this.echarts.init(chartDom);
      this.option1 && this.chart1.setOption(this.option1);
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.tableContainer) {
          return;
        }

        // this.chartHeight = this.$refs.container.offsetHeight - this.$refs.top.offsetHeight - this.$refs.title.offsetHeight - 40;
        if (!this.chart1) {
          return;
        }
        console.log(333)

        this.chart1.getDom().style.height = this.chartHeight + 'px';
        this.chart1.resize();


        this.contentHeight = this.$refs.tableContainer.offsetHeight - this.$refs.titleBar.offsetHeight - 20;
        console.log(this.contentHeight)
        this.rowHeight = (this.contentHeight - 42 - 5) / 8;
      }, 800);
    }
  }
};
</script>
